import { gql } from "@apollo/client";




const GENERATE_LINK_TOKEN = gql`
query GenerateLinkToken($config: GenerateLinkTokenConfigs) {
  generateLinkToken(config: $config) {
    expiration
    link_token
    request_id
  }
}
`;

const FIND_PLAID_ACCESS_TOKENS = gql`
query FindPlaidAccessToken($args: CombinedUpdatePlaidAccessToken) {
  findPlaidAccessToken(args: $args) {
    _id
    accessToken
    brokerage
    brokerageLogin
    itemId
    status
    tokenType
    tokenEnvironment
    numFailedAssets
    createdAt
    updatedAt
  }
}
`;

const FIND_PLAID_ACCESS_TOKENS_UPDATE_AMOUNT = gql`
  query FindPlaidAccessTokenToUpdateAmount {
    findPlaidAccessTokenToUpdateAmount
  }
`;



export { GENERATE_LINK_TOKEN, FIND_PLAID_ACCESS_TOKENS, FIND_PLAID_ACCESS_TOKENS_UPDATE_AMOUNT };